import { render } from "./Popular-flowers.vue?vue&type=template&id=10a40644&scoped=true"
import script from "./Popular-flowers.vue?vue&type=script&lang=js"
export * from "./Popular-flowers.vue?vue&type=script&lang=js"

import "./Popular-flowers.vue?vue&type=style&index=0&id=10a40644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a40644"]])

export default __exports__